import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f5997d7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pdf-content" }
const _hoisted_2 = { class: "pdf-title" }
const _hoisted_3 = { class: "mt-4 border-top-1" }
const _hoisted_4 = { class: "my-8" }
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs font-bold text-center my-2" }, "Legende", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-2 border-top-1 border-bottom-1 text-xs flex flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 mr-8" }, [
    /*#__PURE__*/_createTextVNode(" Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 mx-8" }, [
    /*#__PURE__*/_createTextVNode(" Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "my-2 mx-8" }, [
    /*#__PURE__*/_createTextVNode(" Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Lore Ipsum Item ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf_acon_logo = _resolveComponent("pdf-acon-logo")!
  const _component_pdf_general_data = _resolveComponent("pdf-general-data")!
  const _component_pdf_a4_page = _resolveComponent("pdf-a4-page")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_pdf_a4_page, { "pdf-key": _ctx.lang }, {
      default: _withCtx(() => [
        _createVNode(_component_pdf_acon_logo),
        _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.t("immobilie.pdf.kopfzeile360Inventory", 1, { locale: _ctx.lang})) + " Heizzentrale ", 1),
        _createVNode(_component_pdf_general_data, {
          hzba: _ctx.hzba,
          immobilie: _ctx.immobilie,
          lang: _ctx.lang
        }, null, 8, ["hzba", "immobilie", "lang"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.t("immobilie.pdf.anlagenschema", 1, { locale: _ctx.lang})), 1),
          _createElementVNode("img", {
            src: _ctx.getPhotoUrl(_ctx.immobilie?.anlagenschema),
            height: "400",
            class: "object-cover"
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    }, 8, ["pdf-key"])
  ]))
}